export const notifyMeModalTypes = Object.freeze({
  comingSoon: 'Coming Soon',
  soldOut: 'Sold Out'
})

export const CartTypes = Object.freeze({
  Cart: 'Cart',
  Checkout: 'Checkout',
  Confirmation: 'Confirmation'
})

export const WebshopQueryParams = Object.freeze({
  credits: 'credits',
  status: 'status'
})

export const WebshopPaymentStatuses = Object.freeze({
  failed: 'failed',
  pending: 'pending'
})
